<template>
  <section>
    <!--                                                        photo list-->
    <span v-for="photo in photos" v-bind:key="photo.id" class="mt-1">
        <b-link :href="photo.location" target="_blank">
            <b-img :src="photo.location" class="photo"/>
        </b-link>
        <button type="button"
                class="btn btn-danger delete mr-1 ml-1"
                v-on:click="deletePhoto(photo.id)"
        >
            <i class="fa fa-minus"></i>
        </button>
    </span>
    <!--                                                        photo form-->
    <div class="mt-5">
      <div v-for="number in photoNumber" v-bind:key="number" class="mt-1">
        <section v-if="isExistField(number)">
          <b-form-file
              id="input-16"
              class="photos-input"
              accept="image/*"
              placeholder="Картинка ..."
              v-model="newPhotos[number]"
          ></b-form-file>
          <span class="input-group-btn pull-right ml-2">
                  <button type="button" class="btn btn-danger delete"
                          v-on:click="deletePhotoField(number)"
                          v-if="photoNumber > 0"
                  ><i class="fa fa-minus"></i></button>
          </span>
        </section>
      </div>
    </div>
    <div class="mt-1">
      <section>
        <span class="photos-input">&nbsp;</span>
        <span class="input-group-btn pull-right ml-2">
            <button type="button"
                    class="btn btn-success clonspan"
                    v-on:click="addNewPhotoField()"
                    title="Добавить картинку"
            >
                <i class="fa fa-plus"></i
                ></button>
        </span>
      </section>
    </div>
  </section>
</template>

<script>


export default {
  name: "photoForm",
  props: {
    photos: {
      type: Array,
      required: true
    },
    newPhotos: {
      type: Object,
      required: true
    },
    deletedPhoto: {
      type: Function,
      required: true
    },
  },

  data() {
    return {
      photoNumber: 0
    }
  },
  methods: {
    addNewPhotoField() {
      this.photoNumber ++
      this.$set(this.newPhotos, this.photoNumber,  [])
    },
    deletePhotoField(number) {

      this.newPhotos[number] = null
      this.$forceUpdate()
    },
    deletePhoto(photoId) {
      for (let key in this.photos) {
        if (this.photos[key].id === photoId) {
          this.photos.splice(key, 1)
        }
      }
      this.deletedPhoto(photoId)
    },
    isExistField(number) {
      return this.newPhotos[number] !== null
    },
  },
  computed: {

  },
  mounted() {
  },
  created() {
    
  },
}
</script>

<style scoped>
.photo {
  max-height: 6em;
}
</style>